import React, { useState, useEffect, createElement } from 'react';
import { Box, Button, Icon, Dialog, Transfer } from '@alifd/next';
const OadpAttributeSettingTransfer = function OadpAttributeSettingTransfer({ children, attributeDataSource, attributeShowDataSource, onOpen, onConfirm, __designMode, ...otherProps }) {
    const [localValues, setLocalValues] = useState(attributeShowDataSource);
    const [visibleTableSetting, setVisibleTableSetting] = React.useState(false);
    useEffect(() => {
        setLocalValues(attributeShowDataSource || []);
    }, [attributeShowDataSource]);
    const handleDialogOpen = () => {
        onOpen?.();
        if (__designMode === 'design') {
            console.log('OadpEntityButtonReadCondition handleDialogOpen __designMode === design');
            return;
        }
        setVisibleTableSetting(true);
    };
    const handleDialogOk = () => {
        onConfirm?.(localValues);
        setVisibleTableSetting(false);
    };
    const handleTransferChange = (value, data, extra) => {
        setLocalValues(value);
    };
    return (createElement(Box, { direction: "row", justify: 'start', align: 'center' },
        createElement(Button, { onClick: handleDialogOpen, text: false, type: "secondary", size: "medium", iconSize: "medium", icons: { loading: createElement(Icon, { type: "set" }) }, style: { paddingLeft: 4, paddingRight: 4, border: 'none' }, "aria-label": "set button" },
            createElement(Icon, { type: "set", size: "large" })),
        createElement(Dialog, { title: "\u8BBE\u7F6E", overflowScroll: true, visible: visibleTableSetting, onOk: handleDialogOk, onCancel: () => setVisibleTableSetting(false), onClose: () => setVisibleTableSetting(false), style: { width: '50%', height: '70%' }, v2: true, closeMode: ['close', 'mask', 'esc'] },
            createElement(Box, { direction: "column", align: 'center' },
                createElement(Transfer, { sortable: true, value: localValues, searchProps: {
                        hasClear: true,
                        style: { width: '225px' }
                    }, listStyle: { width: '225px', height: '300px' }, onChange: handleTransferChange, useVirtual: true, dataSource: attributeDataSource, titles: ['未展示', '已展示'], showSearch: [true, true], notFoundContent: ['请选择数据', '请选择数据'] })))));
};
export default OadpAttributeSettingTransfer;
